import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MediaPatchBody, patchMedia } from "@jconradi/tutu-porn-api-client/src/media";
import { MediaListItem } from "@jconradi/tutu-porn-api-client/src/users";
import { startTranscode } from "@jconradi/tutu-porn-api-client/src/transcode";

export interface ModeratorToolbarProps {
    media: MediaListItem;
}
export const ModeratorToolbar = ({ media }: ModeratorToolbarProps) => {
    const queryClient = useQueryClient();

    const { slug } = media;

    const mutation = useMutation<MediaListItem, unknown, MediaPatchBody>({
        mutationFn: async (data: MediaPatchBody) => {
            const resp = await patchMedia(slug, data);

            return resp.data;
        },
        onSuccess: data => {
            queryClient.setQueryData(['media', 'slug', slug], data)
        }
    });

    const forceTranscode = async () => {
        await startTranscode(slug)
    }

    return (
        <div className="flex flex-col gap-y-2">
            <h3 className="font-semibold">Moderator Tools</h3>
            <div className="flex flex-row sm:items-center gap-x-4 bg-primary rounded-md p-8">
                {media.isApproved &&
                    <button onClick={() => { mutation.mutate({ isApproved: false })}} className="btn btn-error">Block</button>
                }
                {!media.isApproved &&
                    <button  onClick={() => { mutation.mutate({ isApproved: true })}}  className="btn btn-success">Approve</button>
                }
                <button onClick={() => forceTranscode()} className="btn">Force Transcode</button>
            </div>
        </div>
    )
}